function scrollAnchor(elRef, threshold = 24) {
  function getState() {
    const el = elRef.value;
    if (!el) return { atBottom: true, scrollTop: 0 };

    const max = el.scrollHeight - el.clientHeight;

    return {
      atBottom: max - el.scrollTop <= threshold,
      scrollTop: el.scrollTop,
    };
  }

  function restore(state) {
    const el = elRef.value;
    if (!el) return;

    if (state.atBottom) {
      el.scrollTop = el.scrollHeight;
    } else {
      el.scrollTop = state.scrollTop;
    }
  }

  return { getState, restore };
}

export default scrollAnchor;
